// extracted by mini-css-extract-plugin
export default {"button":"im8b5t","mobile":"wWoEjT","mobileFontSize":"et_rtM","star":"kTL1KI","starFilled":"I9qN9h"};